import { makeStyles } from "@fluentui/react-components";

export const useStyle = makeStyles({
	combobox: {
		width: "100%",
	},
	listbox: {
		// Queues and flows are one line each, so this holds about nine of them. The viewport share keeps
		// the list inside a short window, where the fixed part alone would push it off the bottom.
		maxHeight: "min(60vh, 300px)",
	},
	optionRow: {
		paddingLeft: "16px",
		paddingRight: "16px",
	},
});
